export default "__VITE_ASSET__DI37Yz3A__";